import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Meter from 'aria-viewer/utils/fpsMeter'

class FPSMeter extends PureComponent {
    componentDidMount() {
        const { enabled } = this.props

        if (enabled) this.startMeter()
    }

    componentWillReceiveProps(nextProps) {
        const { enabled } = nextProps
        const { enabled: prevEnabled } = this.props

        if (prevEnabled && !enabled) this.stopMeter()
        else if (!prevEnabled && enabled) this.startMeter()
    }

    componentWillUnmount() {
        this.stopMeter()
    }

    loop = () => {
        this.raf = requestAnimationFrame(this.loop)
        if (Meter.isOn) Meter.update()
    }

    startMeter = () => {
        Meter.start()
        this.interval = setInterval(this.calculateMean, this.props.interval)
        this.loop()
    }

    stopMeter = () => {
        Meter.stop()
        this.raf && cancelAnimationFrame(this.raf)
        this.interval && clearInterval(this.interval)
    }

    calculateMean = () => {
        const { onInterval } = this.props
        Meter.calculateMean()

        onInterval && onInterval(Meter.mean)

        Meter.reset()
    }

    render() {
        return null
    }
}

FPSMeter.propTypes = {
    interval: PropTypes.number,
    enabled: PropTypes.bool,
}

FPSMeter.defaultProps = {
    interval: 3000,
    enabled: true,
}

export default FPSMeter
